import { render } from "./HomeScreen.vue?vue&type=template&id=0a4d1b66&scoped=true"
import script from "./HomeScreen.vue?vue&type=script&lang=js"
export * from "./HomeScreen.vue?vue&type=script&lang=js"

import "./HomeScreen.vue?vue&type=style&index=0&id=0a4d1b66&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a4d1b66"]])

export default __exports__